// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__10Jhx","buttons":"SendReceipts_buttons__3BIPy","email":"SendReceipts_email__CBFxA","bookApptTitle":"SendReceipts_bookApptTitle__NY2Gf"};